/**
 * @see https://router.vuejs.org/en/advanced/scroll-behavior.html
 * @param to
 * @param from
 * @param savedPosition
 * @returns {*}
 */

/**
 * Determine if the user is searching the current page, using
 * the following rules:
 * 1. They are navigating to and from the same page.
 * 2. The page they're going to matches the resource name given here.
 * 3. The fullPath of the `to` url is not the basic form (/contacts).
 *
 * #3 allows the user to click a `reset` or the nav link in order to
 * skip back to the top of the page.
 *
 * @param {string } resource
 * @param {string} url
 */
function isSearchingPage(to, from, resource, url = null) {

  if (!url) url = `/${resource}`;

  if (from.name === to.name &&
    to.name === resource &&
    to.fullPath !== url) {
    return true;
  }

  return false;
}

export default function(to, from, savedPosition) {

  // Don't scroll to top if searching on the contacts page
  // This functionality could be generalized to _all_ pages
  if (isSearchingPage(to, from, 'contacts')) return;

  // When not an anchor, scroll back to top
  if (!to.hash) return { x: 0, y: 0 };

  // When an anchor, scroll to anchor but leave room for the header
  return {
    selector: to.hash,
    offset: { y: 84 }, // Header height + some padding
  };
}
